import React, {useEffect} from 'react';
import './App.css';
import './bootstrap.min.css'
import {
    createBrowserRouter,
    createHashRouter,
    RouterProvider, useSearchParams,
} from "react-router-dom";
import {routes} from "./routes/router";
import useUserStore from "./store/userStore";
import useAlertStore from "./store/alertStore";

const router = createHashRouter(routes)

function App() {

    const {setToken,setFIO,setLogin} = useUserStore();
    const {addAlert} = useAlertStore()

    useEffect(()=>{
        const queryString = window.location.search;
        const searchParams = new URLSearchParams(queryString);
        let token = searchParams.get('token');
        let fio = searchParams.get('fio');
        let login = searchParams.get('login');
        if(token)
            setToken(token);
        if(fio)
            setFIO(fio);
        if(login)
            setLogin(login);
        if(token || fio || login) {
            //const params = GetAllSearchParams(searchParams);
            // @ts-ignore
            //delete params['token'];
            // @ts-ignore
            //delete params['fio'];
            // @ts-ignore
            //delete params['login'];
            //setSearchParams({...params});
            window.location.search = '';
            addAlert({uid: String(Date.now()), type: "success", message: "Вы успешно авторизовались!"}, 10000);
        }
    })

  return (
        <RouterProvider router={router}/>
  );
}

export default App;
